import { useState, useRef, useEffect } from 'preact/hooks'
import { v4 as uuidv4 } from 'uuid'
import clsx from 'clsx'
import Icon from 'snippets/icon/icon'

function AccordionItem({
  defaultActive,
  heading,
  content,
  wrapperClass,
  titleClass,
  itemDescriptionClass,
  maxHeightContent = 0,
  filter,
  accordionIndex,
  currentAccordionIndex,
  setCurrentAccordionIndex = () => {}
}) {
  const contentRef = useRef(null)
  const [style, setStyle] = useState('max-height: 0')
  const [id] = useState(uuidv4())
  let isActive = currentAccordionIndex === accordionIndex

  const onToggle = () => {
    if (isActive) {
      setCurrentAccordionIndex(null)
      setStyle('max-height: 0')
    } else {
      const maxHeight = maxHeightContent > 0 ? maxHeightContent : contentRef.current.scrollHeight

      setCurrentAccordionIndex(accordionIndex)
      setStyle(`max-height: ${maxHeight}px`)
    }
  }

  useEffect(() => {
    if (defaultActive && !isActive) {
      onToggle()
    } else if (!defaultActive && isActive) {
      isActive = false
      setStyle('max-height: 0')
    }
  }, [defaultActive])

  useEffect(() => {
    if (isActive) {
      const maxHeight = maxHeightContent > 0 ? maxHeightContent : contentRef.current.scrollHeight

      setStyle(`max-height: ${maxHeight}px`)
    } else {
      setStyle('max-height: 0')
    }
  }, [isActive, content, maxHeightContent])

  return (
    <div className={`accordion-item ${wrapperClass}`} open={isActive}>
      <button
        type="button"
        className={`accordion-item-title ${titleClass}`}
        onClick={onToggle}
        aria-expanded={isActive}
        id={`accordion-control-${id}`}
        aria-controls={`accordion-panel-${id}`}
      >
        <div className="mr-8">{heading}</div>
        <Icon
          viewBox="0 0 16 16"
          name="icon-chevron-down"
          className={clsx('accordion-item-icon rotate transition-all duration-300', isActive && 'rotate-180')}
        />
      </button>
      <div
        ref={contentRef}
        className={clsx(`accordion-item-description js-accordion-description ${itemDescriptionClass}`, {
          'overflow-y-auto': maxHeightContent > 0 && filter?.type !== 'price_range',
          'overflow-visible': filter?.type === 'price_range' && isActive
        })}
        style={style}
        id={`accordion-panel-${id}`}
      >
        {content}
      </div>
    </div>
  )
}

export default AccordionItem
